import React, { Fragment } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Grid, IconButton, Button, Tooltip } from "@material-ui/core";

import svgImage7 from "../../assets/images/illustrations/blocked.svg";

import { NavLink as RouterLink } from "react-router-dom";

import { useIntl, FormattedMessage } from "react-intl";

import { formatMessage } from "utils/MyFunctions";

export default function LivePreviewExample() {
  const intl = useIntl();
  return (
    <Fragment>
      <div className="app-wrapper bg-light">
        <div className="app-main">
          <div className="app-content p-0">
            <div className="app-inner-content-layout--main">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content">
                  <div className="hero-wrapper bg-composed-wrapper min-vh-100">
                    <div className="flex-grow-1 w-100 d-flex align-items-center">
                      <Grid
                        item
                        lg={6}
                        md={9}
                        className="px-4 mx-auto text-center text-black"
                      >
                        <img
                          src={svgImage7}
                          className="w-50 mx-auto d-block my-5 img-fluid"
                          alt="Blocked user"
                        />

                        <h1 className="display-1 mb-3 px-4 font-weight-bold">
                          {formatMessage(intl, "page_error_blocked_title")}
                        </h1>
                        <h3 className="font-size-xxl line-height-sm font-weight-light d-block px-3 mb-3 text-black-50">
                          {formatMessage(
                            intl,
                            "page_error_blocked_description"
                          )}
                        </h3>
                        <p>{formatMessage(intl, "page_error_blocked_more")}</p>
                        <Button
                          component={RouterLink}
                          to="/Listebesc"
                          size="large"
                          color="primary"
                          variant="contained"
                          className="text-white mt-4"
                        >
                          <span className="btn-wrapper--icon">
                            <FontAwesomeIcon icon={["fas", "arrow-left"]} />
                          </span>
                          <span className="btn-wrapper--label">
                            {formatMessage(intl, "page_error_blocked_btn")}
                          </span>
                        </Button>
                      </Grid>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
